module.exports = __webpack_public_path__ + "static/HorizontalPush-PushUp-557374d3632a99246be0f4410427c1a6.mp4";